export default __webpack_public_path__ + "static/besanbarfi-580be04b9e42eef4f52d113ff96c6625.png";